import { Environment } from './environment';

export const environment: Environment = {
  baseURL: 'https://prodatex-prod-be.zamia.be',
  daccaBaseURL: 'https://dacca.zamia.be',
  appInsightsInstrumentationKey: 'fd5e0311-3d58-402e-a7c8-3a9becffccce',
  networkHealthTimeout: 5000,
  maxImageHeight: 600,
  maxImageWidth: 1080,
  imageQuality: 50,
  oktaAuthorizeUrl: 'https://belfius.okta.com/oauth2/aus7fs1yljXQzYNDs417/v1/authorize',
  oktaClientId: '0oa3rrd5dcijn2jQl417', // prodatex-okta.zamia.be
  useOkta: true,
  oktaLogoutUrl: 'https://belfius.okta.com/login/signout'
};
